import debounce from 'lodash/debounce'
import React, { useMemo, useState } from 'react'

import { Button } from '@/legacy-src/components/ui/button'
import { cn } from '@/legacy-src/lib/utils'

import { getTranslate } from '../../utilities/i18n'
import { sanitizeTextForSearch } from '../../utilities/textUtilities'
import useOutsideClick from '../../utilities/useClickOutside'
import Icon from '../icons/Icon'
import { FILTER_SEARCH_SLUG } from './filters.constants'
import useFilters from './hooks/useFilters'

const SearchName = () => {
  const { t } = getTranslate()
  const [isOpen, setIsOpen] = useState(false)
  const [inputValue, setInputValue] = useState<string>('')
  const { setFilters, getFilterValue } = useFilters()

  const toggleOpen = () => {
    setIsOpen((prev) => {
      const value = getFilterValue(FILTER_SEARCH_SLUG)
      setInputValue(value[0])
      return !prev
    })
  }

  const handleClickOutside = () => setIsOpen(false)
  const ref = useOutsideClick(handleClickOutside)

  const handleSearch = (value: string) => {
    const name = sanitizeTextForSearch(value)

    setFilters([{ slug: FILTER_SEARCH_SLUG, value: name }])
  }

  const handleSearchDebounced = useMemo(() => debounce(handleSearch, 300), [handleSearch])

  const handleInputChange = (event: React.FormEvent<HTMLInputElement>) => {
    handleSearchDebounced(event.currentTarget.value)
  }

  return (
    <div ref={ref} className="tablet:relative">
      <Button
        variant="light"
        size="small"
        onClick={toggleOpen}
        className={cn('h-[38px] rounded-full px-2 py-1 text-text-color hover:text-text-color')}
      >
        <Icon color="primary" icon="search" size="sm" />
      </Button>

      {isOpen && (
        <div className="absolute right-0 z-10 mt-2 w-80 rounded-2xl bg-white shadow-hedepy big-phone:w-96">
          <div className="form-group my-4 px-5">
            <input
              name="search"
              autoFocus
              placeholder={t('components.filter.search.placeholder')}
              className={`form-control`}
              onChange={handleInputChange}
              defaultValue={inputValue ?? undefined}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchName
